module.exports = __webpack_public_path__ + "static/img/link_young_employee.95f6dc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/link_young_employee.svg
// module id = q4Fn
// module chunks = 0